import React from 'react';
import _ from 'lodash';
import { Field } from 'redux-form';
import renderField from './renderField';
import { ApiHost, EmeraldHost } from '../config';
import StudentSectionCard from './StudentSectionCard';
import loadingGif from '../assets/img/loading-pinwheel.gif';
import '../assets/css/components/student-registration-form.css';

const StudentRegistrationForm = props => {
  const { courses, sections, currentUser, isAsyncValidating, studentIsLoggedIn, usernameError, submitWasSuccessful, isSubmitting, submitError, onSubmitNew } = props

  const getCourseForSection = section =>_.find(courses, course=>course.id === String(section.course_id))

  return(
    <div className='student-registration-form'>
      <div className='col-xs-12'>
        <form onSubmit={onSubmitNew}>
          <div className='registration-code-row'>
            <h1 style={{ textAlign: 'center' }}>New Class Code:</h1>
          </div>
          <div className='single-field-row row'>
            <div className='col-md-4'>
              {submitError && <div className='error'>{submitError}</div>}
              <Field
                name='student[registration_code]'
                type='text'
                label='Registration Code'
                isNew={true}
                component={renderField}
              />

              <button disabled={isSubmitting || usernameError || isAsyncValidating} className='btn btn-lg btn-success'>Register</button>
              <img className={`loading-gif ${(isSubmitting || isAsyncValidating) ? '' : 'hidden'}`} src={loadingGif}/>
              {submitWasSuccessful &&
                <h2>Success!</h2>
              }
            </div>
          </div>
          
          <br/><br/>
          {!_.isEmpty(sections) &&
            <div>
              <h2>Your current classes:</h2>
              <div className='row'>
                {_.map(sections, section=>
                  <StudentSectionCard section={section} course={getCourseForSection(section)}/>
                )}
              </div>
            </div>
          }
          {_.isEmpty(sections) && studentIsLoggedIn &&
            <h2>You are not currently enrolled in any classes.</h2>
          }
        </form>
      </div>
    </div>
  );
}

export default StudentRegistrationForm;
